module.exports = __webpack_public_path__ + "img/coperta_cod_rutier.a8538b61.png";